export const IMG = {
  hero: "https://images.unsplash.com/photo-1613214149922-f1809c99b414?q=80&auto=format&fit=crop&w=1600",
  van: "/van.jpg",
  tread: "https://images.unsplash.com/photo-1571335746824-742511d49bce?q=80&auto=format&fit=crop&w=1400",
  tireWheel: "https://images.unsplash.com/photo-1601411101851-ea0e07766235?q=80&auto=format&fit=crop&w=1400",
  rimDark: "https://images.unsplash.com/photo-1611633235555-45e252fe48c8?q=80&auto=format&fit=crop&w=1400",
  rimRed: "https://images.unsplash.com/photo-1616788902258-138db56fe7e5?q=80&auto=format&fit=crop&w=1400",
  roadside: "https://images.unsplash.com/photo-1620707044570-c0dc1576bedd?q=80&auto=format&fit=crop&w=1400",
  flat: "https://images.unsplash.com/photo-1568775376697-e16970e74861?q=80&auto=format&fit=crop&w=1400",
  shelf: "https://images.unsplash.com/photo-1580053852056-f3992ab1e5e5?q=80&auto=format&fit=crop&w=1400",
  pile: "https://images.unsplash.com/photo-1578844251758-2f71da64c96f?q=80&auto=format&fit=crop&w=1400",
  assorted: "https://images.unsplash.com/photo-1527266258038-6ae3e089a609?q=80&auto=format&fit=crop&w=1400",
  riyadh: "https://images.unsplash.com/photo-1742084312070-0a952dff8b8c?q=80&auto=format&fit=crop&w=1600",
  grayRim: "https://images.unsplash.com/photo-1444947295498-07f60c19a4ff?q=80&auto=format&fit=crop&w=1400",
  tire2: "https://images.unsplash.com/photo-1585252522525-4f9ad48a24ea?q=80&auto=format&fit=crop&w=1400",
};

const STEPS = [
  "راسلنا عبر واتساب",
  "أرسل موقعك الحالي للفني",
  "نصل إلى موقعك أينما كنت",
  "ننفّذ الخدمة في الموقع وستكمل رحلتك",
];

const svc = (data) => ({ steps: STEPS, ...data });

export const SERVICES = [
  svc({
    slug: "بنشر-متنقل-الرياض",
    name: "بنشر متنقل الرياض",
    h1: "بنشر متنقل في الرياض — نصل إليك أينما كنت",
    title: "بنشر متنقل الرياض | خدمة بنشر متنقل 24 ساعة — نجم الإطار",
    description: "بنشر متنقل في الرياض يصلك أينما كنت: إصلاح البنشر، تغيير الكفرات، الترصيص وتعبئة الهواء على الطريق. خدمة 24 ساعة في جميع مناطق الرياض. واتساب 0538644740",
    image: IMG.hero,
    alt: "فني بنشر متنقل يغيّر كفر سيارة في الرياض",
    intro: [
      "تعطل الكفر فجأة لا يعني إيقاف يومك. خدمة بنشر متنقل في الرياض من نجم الإطار صُمّمت لتأخذك من الوقوف على حافة الطريق إلى الاستمرار في رحلتك بأسرع وقت. تصل سيارة البنشر المتنقل إلى موقعك — بيتك، مكتبك، مواقف السيارات، أو على حافة الطريق — وتنفّذ ما تحتاجه في الموقع نفسه: إصلاح، تغيير كفرات، ترصيص أو تعبئة هواء.",
      "نغطي الرياض كاملة من الشمال إلى الجنوب ومن الشرق إلى الغرب، ونعمل على مدار 24 ساعة لأن أعطال الكفرات لا تختار وقتاً. لا تحتاج إلى دفع سيارتك أو انتظار دورك في ورشة مزدحمة؛ يكفي رسالة واتساب مع موقعك الحالي، وسيتحرك الفني إليك مباشرة.",
    ],
    sections: [
      {
        h2: "ماذا تشمل خدمة البنشر المتنقل؟",
        body: "وحدة البنشر المتنقل لدينا تعمل كورشة كاملة متحركة، مجهزة بكل ما يحتاجه إطار سيارتك في الموقع:",
        list: ["إصلاح البنشر وإغلاق الثقوب", "تغيير وتركيب الكفرات مع الموازنة", "ترصيص الإطارات لإزالة الاهتزاز", "فحص وتعبئة الهواء وضبط الضغط", "برمجة حساسات الكفرات TPMS", "تجهيز كفرات وجنوط عند الحاجة"],
      },
      {
        h2: "متى تحتاج إلى بنشر متنقل؟",
        body: "أغلب طلاباتنا تأتي في هذه المواقف:",
        list: ["انفجار أو ثقب مفاجئ في الكفر أثناء القيادة", "انخفاض ضغط متكرر في أحد الكفرات", "اهتزاز في المقود يظهر بسرعات معينة", "فحص الإطارات وضبط الضغط قبل سفر طويل", "تغيير كفرات قديمة بكفرات جديدة دون مغادرة المنزل"],
      },
      {
        h2: "لماذا تختار نجم الإطار في الرياض؟",
        body: "لأننا متخصصون في إطار السيارة فقط. كل ما نقوم به يدور حول الكفرات والإطارات والجنوط وحساسات الضغط، وهذا يجعل خبرتنا مركّزة ومباشرة. نحترم وقتك ونتعامل مع سيارتك بأدوات نظيفة واحترافية، ونشرح لك حالة الإطار قبل أي خطوة، ولا نبدأ عملنا إلا بعد موافقتك على السعر والخدمة.",
      },
    ],
    features: ["تغطية جميع مناطق الرياض", "خدمة على مدار 24 ساعة", "معدات كاملة على متن السيارة", "شرح واضح للحالة قبل البدء"],
    faqs: [
      { q: "هل تصلون إلى جميع مناطق الرياض؟", a: "نعم، نغطي الرياض كاملة: شمال وجنوب وشرق وغرب ووسط — الأحياء، الطرق الداخلية، المواقف والطرق الرئيسية." },
      { q: "هل الخدمة متاحة في الليل؟", a: "نعم، خدمتنا تعمل على مدار 24 ساعة طوال أيام الأسبوع، لأن أعطال الكفرات لا تنتظر الصباح." },
      { q: "هل يمكن تغيير الكفر في موقعي مباشرة؟", a: "نعم، سيارة البنشر المتنقل مجهزة بكل المعدات اللازمة لفك وتركيب الكفرات والموازنة في موقعك دون الحاجة للانتقال إلى ورشة." },
      { q: "كيف أطلب الخدمة؟", a: "أرسل لنا رسالة واتساب، وشارك موقعك الحالي عبر زر «أرسل موقعك للفني» ليتحرك أقرب فني إليك فوراً." },
    ],
  }),
  svc({
    slug: "بنشر-متنقل-نجم-الاطار",
    name: "بنشر متنقل نجم الإطار",
    h1: "نجم الإطار — تخصصك في البنشر المتنقل بالرياض",
    title: "بنشر متنقل نجم الإطار | نصلك أينما كنت في الرياض",
    description: "بنشر متنقل نجم الإطار — علامة متخصصة في خدمة الكفرات المتنقلة بالرياض: إصلاح، تغيير، إطارات، جنوط وبرمجة TPMS على مدار الساعة.",
    image: IMG.van,
    alt: "فانيلا بنشر متنقل نجم الإطار الرسمية بالأزرق والأصفر — نصلك أينما كنت",
    intro: [
      "«نجم الإطار» اسم يعبر عن تخصصنا: كل ما يدور حول إطار سيارتك — من الكفر إلى الجنط إلى حساس الضغط — هو عملنا اليومي. بدأنا بهذا الشعار: نصلك أينما كنت، ولذلك بنينا خدمتنا كاملة على أساس الحركة إلى العميل بدل انتظاره في ورشة.",
      "عندما تواصل مع نجم الإطار، فأنت تتعامل مع فريق يصل إليك بسيارة مجهزة بالكامل: معدات رفع، آلة تفكيك وتركيب، جهاز موازنة وترصيص متنقل، وعُدّة كفرات جديدة بمقاسات متعددة، وأجهزة برمجة حساسات TPMS. الهدف واحد: أن تستكمل رحلتك من دون أن تقود سيارتك إلى ورشة.",
    ],
    sections: [
      {
        h2: "ما الذي يحمله فريقنا؟",
        body: "كل شيء تحتاجه خدمة الإطار في الموقع:",
        list: ["معدات رفع وفك وتركيب كاملة للسيارات والـ SUV", "جهاز موازنة وترصيص متنقل", "كفرات جديدة بمقاسات شائعة في السوق السعودي", "حساسات TPMS وأجهزة برمجتها", "مكابس هواء وأدوات فحص الضغط والتآكل"],
      },
      {
        h2: "معايير عملنا",
        body: "نلتزم بقواعد ثابتة في كل طلب:",
        list: ["شرح الحالة قبل البدء وبعد انتهاء العمل", "العمل بكفرات وحساسات من ماركات معروفة", "الالتزام بالوقت المتفق عليه", "نظافة الموقع بعد الانتهاء — لا نترك آثار عمل وراءنا"],
      },
      {
        h2: "لماذا اخترنا تخصص البنشر المتنقل؟",
        body: "لأن أكثر من نصف حالات تعطل الكفرات لا تحتاج إلى ورشة كاملة؛ تحتاج فنيّاً محترفاً يصل إلى الموقع بأدوات صحيحة. ولهذا جعلنا من الخدمة المتنقلة أساس عملنا: لتوفر على العميل وقته، ولتكون الحل الأمثل في المواقف الحرجة مثل الطريق السريع أو أعطال الليل.",
      },
    ],
    features: ["علامة متخصصة في الإطارات فقط", "معدات كاملة على متن السيارة", "التزام بالمواعيد", "شفافية في الحالة والسعر"],
    faqs: [
      { q: "هل عندكم ورشة ثابتة؟", a: "خدمتنا مبنية على الحركة إليك: نصل إلى موقعك بالسيارة المجهزة وننفّذ العمل هناك. وهذا يعني توفير وقتك في أي موقع داخل الرياض." },
      { q: "هل تتعاملون مع جميع أنواع السيارات؟", a: "نعم، من السيدان إلى الـ SUV والبيك أب والسيارات الفخمة، مع كفرات بمقاسات متعددة تناسب أغلب الموديلات." },
      { q: "هل تستخدمون كفرات أصلية؟", a: "نعم، نتعامل مع ماركات عالمية معروفة، ونوضح لك نوع الكفر ومواصفاته وضمانه قبل التركيب." },
      { q: "كيف أتحقق من هوية الفني؟", a: "عند الطلب نرسل لك تفاصيل الفني المتحرك إليك، لنتعرف عليه قبل وصوله إلى موقعك." },
    ],
  }),
  svc({
    slug: "بنشر-متنقل-قريب-مني",
    name: "بنشر متنقل قريب مني",
    h1: "بنشر متنقل قريب منك — الأقرب إلى موقعك في الرياض",
    title: "بنشر متنقل قريب مني | أقرب بنشر متنقل في الرياض — نجم الإطار",
    description: "تبحث عن بنشر متنقل قريب مني في الرياض؟ نجم الإطار يرسل أقرب فني متحرك إلى موقعك في أي حي. أرسل موقعك الآن أو راسلنا واتساب 0538644740.",
    image: IMG.roadside,
    alt: "فني بنشر متنقل يعمل على كفر سيارة قرب طريق في الرياض",
    intro: [
      "عندما يتعطل الكفر، أول ما تبحث عنه هو «بنشر متنقل قريب مني» — لأن الوقت هو أهم شيء في هذه اللحظة. فريق نجم الإطار يتحرك داخل الرياض بخدمة ميدانية سريعة، ولذلك نرسل إليك أقرب فني متاح لموقعك بدل أن تجبرك على الوصول إلى ورشة ثابتة.",
      "كل ما عليك هو مشاركة موقعك الحالي عبر زر «أرسل موقعك للفني» المتوفر في كل صفحات الموقع، أو وصف موقعك في رسالة واتساب — اسم الحي، أقرب مسجد أو معلم مشهور، أو رابط الموقع من خرائط جوجل. الفني سيصل إلى نقطة وقوفك مباشرة دون التنقل في شوارع فرعية.",
    ],
    sections: [
      {
        h2: "كيف تصل الخدمة إليك أسرع؟",
        body: "ثلاث خطوات قصيرة تجعل وصول الفني أسرع:",
        list: ["حدد موقعك بدقة: إما عبر مشاركة الموقع الجغرافي من الجوال أو رابط خريطة جوجل", "اذكر نوع سيارتك ومقاس الكفر إن كنت تعرفه — لنحضر الكفر المناسب مع الفني", "ابقَ في المكان الآمن: حاف الطريق أو المواقف أو الجانب الواسع من الشارع"],
      },
      {
        h2: "أين تجدنا في الرياض؟",
        body: "نخدم الرياض كاملة، وتشرح صفحات المناطق التالية التغطية في مكانك:",
        list: ["شمال الرياض: العليا، الصحافة، الياسمين، النرجس، الملقا، حطين", "جنوب الرياض: الشفا، العزيزية، الدار البيضاء، بدر", "شرق الرياض: الروضة، النسيم، غرناطة، قرطبة", "غرب الرياض: السويدي، عرقة، ظهرة لبن", "وسط الرياض: الديرة، الصفا، المصل، السلطانة"],
      },
      {
        h2: "ماذا نقدم عندما نصل؟",
        body: "نفس خدمة الورشة لكن في موقعك: إصلاح البنشر أو تغيير الكفر، موازنة وترصيص، ضبط هواء، برمجة حساسات TPMS إذا كانت سيارتك مزودة بها، وشرح واضح لحالة الإطار بعد الانتهاء — فتنطلق من مكانك بنفسك دون سحب أو توصيل.",
      },
    ],
    features: ["أقرب فني يتحرك لموقعك", "مشاركة موقع بضغطة واحدة", "خدمة الليل والصباح", "تغطية الرياض كاملة"],
    faqs: [
      { q: "كيف أجعل الفني يصل أسرع؟", a: "شارك موقعك الجغرافي بدقة عبر زر «أرسل موقعك للفني»، واذكر نوع السيارة ومقاس الكفر — فينتقل الفني بالعتاد الصحيح من أول مرة." },
      { q: "هل تصلون للأحياء الجديدة والطرق الداخلية؟", a: "نعم، تغطيتنا تشمل جميع أحياء الرياض المأهولة والطرق الداخلية والخارجية ضمن حدود المدينة." },
      { q: "هل الخدمة متاحة في وقت متأخر؟", a: "نعم، نعمل على مدار 24 ساعة — بما يشمل ليالي نهاية الأسبوع والأعياد." },
      { q: "هل أحتاج إلى معدات لرفع السيارة؟", a: "لا، الفني يأتي بمعدات الرفع والفك والتركيب كاملة على سيارته." },
    ],
  }),
  svc({
    slug: "تغيير-كفرات-متنقل",
    name: "تغيير كفرات متنقل",
    h1: "تغيير وتركيب الكفرات في موقعك أينما كنت",
    title: "تغيير كفرات متنقل | تبديل وتركيب كفرات في الرياض — نجم الإطار",
    description: "خدمة تغيير كفرات متنقل في الرياض — فك وتركيب الكفرات في موقعك مع موازنة وترصيص. كفرات جديدة وتجهيز وتركيب 24 ساعة. واتساب 0538644740.",
    image: IMG.tireWheel,
    alt: "تركيب كفر جديد على جنط سيارة في موقع العميل بالرياض",
    intro: [
      "تغيير الكفرات لا يجب أن يوقف يومك ولا أن يأخذك إلى ورشة. خدمة تغيير كفرات متنقل من نجم الإطار تنفّذ العملية في مكانك: فك الكفرات القديمة، تركيب الجديدة، الموازنة لكل عجلة، وضبط الضغط الصحيح — من دون أن تتحرك من مكانك.",
      "نجهز لك الكفرات الجديدة من ماركات معروفة، أو نركب كفراتك التي تفضل شراءها من أي مكان. الهدف واحد: أن تكتمل التغييرة بأيدٍ متخصصة وبمعدات موازنة حقيقية — ليس مجرد فك وتركيب بأداة يدوية.",
    ],
    sections: [
      {
        h2: "كيف تتم عملية التغيير؟",
        body: "خطوات واضحة تنفّذ أمام عينك في موقعك:",
        list: ["فحص الكفرات القديمة وتشخيص السبب — ثقب، تقدم في العمر، أو مشكلة في الحمولة", "فك الكفرات القديمة بمعدات صحيحة لا تؤذي الجنوط", "تركيب الكفرات الجديدة مع الموازنة لكل عجلة", "ضبط الضغط على القيمة المناسبة لسيارتك", "فحص الحساسات ولمبة TPMS بعد التركيب"],
      },
      {
        h2: "لماذا الموازنة مهمة بعد التركيب؟",
        body: "كل كفر له اختلاف وزن بسيط عند تصنيعه أو عند تركيبه على الجنط، وأصغر فرق يظهر كاهتزاز في المقود بسرعات عالية أو تآكل غير متساوٍ مع الوقت. الموازنة تعيد توزيع الوزن بدقة، وهي جزء أساسي من خدمة التغيير لدينا، لا إضافة اختيارية.",
      },
      {
        h2: "هل تجهزون الكفرات أم نحضر كفراتكم؟",
        body: "كلاهما. يمكنك طلب كفرات جديدة من عندنا مباشرة (إطارات أصلية بماركات عالمية)، أو إخبارنا بمقاس سيارتك لنجلب لك اقتراحات مناسبة، أو أحضر كفراتك المفضلة ونقوم بفكها وتركيبها وموازنتها في موقعك.",
      },
    ],
    features: ["فك وتركيب في الموقع", "موازنة لكل عجلة", "كفرات جديدة عند الطلب", "ضبط ضغط وفحص حساسات"],
    faqs: [
      { q: "هل تجلبون الكفرات معكم؟", a: "نعم، أخبرنا بمقاس الكفر (مثل 205/55R16) أو نوع سيارتك، وسنجلب لك خيارات مناسبة — أو نركب كفراتك التي تشتريها من أي مكان." },
      { q: "كم يستغرق تغيير 4 كفرات؟", a: "عادة ما يكون العمل ضمن ساعة واحدة، حسب نوع السيارة وحالة الصواميل وحاجة الموازنة." },
      { q: "هل تقومون بفك الكفر عن الجنط في الموقع؟", a: "نعم، سيارتنا المجهزة تحتوي على آلة تفكيك وتركيب متنقلة، فنقوم بذلك في موقعك دون نقل الجنط إلى ورشة." },
      { q: "هل تشمل الخدمة الترصيص؟", a: "نقوم بالموازنة مع كل تركيب، وإذا احتجت ترصيصاً لأي عجلة ننفذه في الموقع نفسه." },
    ],
  }),
  svc({
    slug: "كفرات-الرياض",
    name: "كفرات الرياض",
    h1: "كفرات جديدة في الرياض — مع تركيب عند بابك",
    title: "كفرات الرياض | تجهيز كفرات جديدة وتركيب متنقل — نجم الإطار",
    description: "تبحث عن كفرات الرياض؟ نجم الإطار يجهز لك كفرات جديدة بمقاس سيارتك مع تركيب متنقل في موقعك وموازنة كاملة. تواصل عبر واتساب الآن.",
    image: IMG.shelf,
    alt: "رفوف كفرات جديدة بمقاسات متعددة في الرياض",
    intro: [
      "الرياض تجعل الكفرات تتعب أسرع مما تتوقع: حرارة صيف تصل إلى مستويات تؤثر على مطاط الكفر، مسافات يومية طويلة بين الأحياء والطرق السريعة، وأحياناً مفاجآت الترميمات والحواف الحادة. لهذا اخترنا في نجم الإطار كفرات تناسب أجواء الرياض وتحمل استخدامها اليومي.",
      "اطلب كفراتك عبر واتساب — ونساعدك في اختيار المقاس المناسب — ثم نركبها لك في موقعك: بيتك، عملك، أو موقف سيارتك. لا حاجة إلى رحلة ورشة ولا انتظار؛ الكفر الجديد يصلك ويركب ويوازن ويجري فحص نهائي قبل انطلاقك.",
    ],
    sections: [
      {
        h2: "أنواع الكفرات التي نجهزها",
        body: "اختر ما يناسب سيارتك وطريقتك في القيادة:",
        list: ["كفرات السيدان: راحة وهدوء وتوفير في استهلاك الوقود", "كفرات الـ SUV والكروس أوفر: حمولة وثبات على السرعات", "كفرات رياضية: استجابة أعلى وتماسك في المنعطفات", "كفرات اقتصادية موثوقة للسيارات اليومية"],
      },
      {
        h2: "كيف تعرف أنك اشتريت الكفر الصحيح؟",
        body: "المقاس هو الأساس: اقرأه من إطار باب السائق أو من جانب الكفر الحالي (مثل 205/55R16). بعد المقاس، انظر إلى مؤشر الحمولة ورمز السرعة، ثم ماركة الكفر وسنة صنعه. لا تشترِ كفراً بسعر يبدو مغرياً جداً لمقاسك — الكفر عنصر أمان، وفارق السعر بين الكفر الموثوق وغيره يظهر في الاهتزاز والتشقق مع الحرارة.",
      },
      {
        h2: "كيف تطلب كفراتك؟",
        body: "أرسل لنا مقاس سيارتك عبر واتساب وسنقترح عليك خيارات تناسب ميزانيتك ونوع استخدامك، مع صور واضحة وتسعير صريح قبل أن تقرر. عند تأكيد الطلب نحدد موعداً ونجلب الكفرات إلى موقعك للتركيب والموازنة.",
      },
    ],
    features: ["كفرات بماركات عالمية", "تركيب متنقل في موقعك", "موازنة وضبط ضغط", "تسعير واضح عبر واتساب"],
    faqs: [
      { q: "ما أنواع الكفرات المتوفرة؟", a: "نجهز كفرات السيدان والـ SUV والكروس أوفر والرياضية من ماركات معروفة مثل ميشلان وبريدجستون وكونتيننتال وبيريللي ودنلوب وغيرها، حسب توفر المقاس." },
      { q: "كيف أعرف مقاس كفرتي؟", a: "ستجد المقاس على جانب الكفر أو على ملصق داخل باب السائق — سلسلة أرقام مثل 205/55R16. أو أرسل لنا صورة الكفر على واتساب ونجددها لك." },
      { q: "هل تشمل الخدمة الموازنة؟", a: "نعم، تركيبنا الكامل يشمل الموازنة وضبط الضغط، لأن التركيب بدون موازنة يعني اهتزازاً وتآكلاً غير متساوٍ." },
      { q: "هل يمكن الدفع عند التركيب؟", a: "نعم، يمكنك تأكيد الطلب عبر واتساب والاتفاق على طريقة الدفع عند التركيب في موقعك." },
    ],
  }),
  svc({
    slug: "اطارات-الرياض",
    name: "إطارات الرياض",
    h1: "إطارات في الرياض مع تركيب متنقل",
    title: "إطارات الرياض | تجهيز إطارات وتركيب متنقل — نجم الإطار",
    description: "إطارات الرياض — ماركات عالمية بمقاسات متعددة مع خدمة تركيب متنقلة في موقعك بالرياض وموازنة وترصيص. اطلب عبر واتساب 0538644740.",
    image: IMG.tread,
    alt: "إطارات جديدة بنقشة واضحة — تجهيز وتركيب متنقل في الرياض",
    intro: [
      "الإطار هو الجزء الوحيد من سيارتك الذي يلامس الطريق فعلياً، ولهذا لا نتعامل معه كقطعة تُشترى بأقل سعر. في نجم الإطار نجلب لك إطارات من ماركات عالمية معروفة بمقاسات تناسب أغلب السيارات المنتشرة في الرياض — مع خدمة تركيب متنقلة توصلها إليك وتركبها في مكانك.",
      "سواء كنت تبحث عن طقم كامل أو كفراً واحداً بديلاً، أو تحتاج إطارات قبل سفر طويل أو لسيارة جديدة تريد تجهيزها — نقدم لك خيارات واضحة بالمقاس الصحيح وتسعير صريح عبر واتساب، ثم ننجز التركيب والموازنة في الموقع نفسه.",
    ],
    sections: [
      {
        h2: "ماركات نجهزها",
        body: "نتعامل مع ماركات عالمية لها سجل معروف في أداء الإطارات:",
        list: ["ميشلان Michelin", "بريدجستون Bridgestone", "كونتيننتال Continental", "بيريللي Pirelli", "دنلوب Dunlop", "ماركات اقتصادية موثوقة حسب المقاس"],
      },
      {
        h2: "كيف تختار إطارك الصحيح؟",
        body: "ابدأ من المقاس المكتوب على جانب الإطار الحالي أو بطاقة السيارة. بعدها اختر حسب استخدامك: هدوء وراحة للاستخدام اليومي، ثبات وتحمل للاستخدام الطويل، أو أداء رياضي للسيارات القوية. ولا تنسَ سنة الصنع — الإطار الجديد يجب أن يكون من إنتاج حديث.",
      },
      {
        h2: "التركيب المتنقل — لماذا؟",
        body: "لأن نقل سيارتك إلى ورشة لإطارات يحتاج وقتاً لا يتناسب مع إيقاع حياتك في الرياض. التركيب المتنقل يعني أن الإطار يصلك ويُركب في المكان الذي تختاره، مع موازنة لكل عجلة وضبط ضغط وفحص لحساسات TPMS — ثم تكمل يومك دون انقطاع.",
      },
    ],
    features: ["ماركات عالمية", "مقاسات شائعة متوفرة", "تركيب وموازنة متنقلة", "تسعير واضح قبل الطلب"],
    faqs: [
      { q: "ما الماركات المتوفرة؟", a: "نجهز إطارات من ماركات مثل ميشلان وبريدجستون وكونتيننتال وبيريللي ودنلوب وغيرها حسب المقاس والتوفر." },
      { q: "هل الإطارات أصلية؟", a: "نعم، نتعامل مع موزعين موثوقين وتصلك الإطارات بسنة صناعة حديثة، ونشرح لك مواصفات كل إطار قبل الشراء." },
      { q: "هل يمكنني طلب الإطارات دون تركيب؟", a: "نعم، يمكنك طلب الإطارات وحدها، لكننا نوصي دائماً بالتركيب مع الموازنة لضمان أداء صحيح." },
      { q: "هل توصلون الإطارات خارج الرياض؟", a: "خدمة التركيب المتنقل مخصصة لمدينة الرياض وضواحيها القريبة. للاستفسار عن أي منطقة خارج المدينة تواصل معنا عبر واتساب." },
    ],
  }),
  svc({
    slug: "جنوط-الرياض",
    name: "جنوط الرياض",
    h1: "جنوط في الرياض — تجهيز وتركيب متخصص",
    title: "جنوط الرياض | تجهيز وتركيب جنوط في الرياض — نجم الإطار",
    description: "جنوط الرياض — تشكيلة جنوط بمقاسات من 16 إلى 19 بوصة، تركيب متنقل في موقعك مع فحص التوافق. راسلنا على واتساب 0538644740 لاختيار الجنط المناسب.",
    image: IMG.rimDark,
    alt: "جنط رياضي بتصميم عصري على خلفية داكنة في الرياض",
    intro: [
      "الجنط ليس شكلاً فقط — هو قياسات دقيقة تحدد ثباتك وراحة مقودك. في نجم الإطار نجلب لك جنوطاً بمقاسات من 16 إلى 19 بوصة مع فحص التوافق الكامل مع سيارتك: مؤشر الحمولة، خلوص البراغي (PCD)، والعرض المناسب لمقاس كفرك.",
      "بعد اختيار الجنط المناسب، ننجز التركيب في زيارة واحدة إلى موقعك — منزل أو عمل أو موقف — نركب الجنوط مع الكفرات، نوازن كل عجلة، ونضبط الضغط. نتيجة نهائية جاهزة للانطلاق دون يوم ضائع في ورشة.",
    ],
    sections: [
      {
        h2: "كيف تختار الجنط المناسب؟",
        body: "ثلاثة قياسات تحدد التوافق:",
        list: ["القطر: يجب أن يتناسب مع مقاس الكفر المتاح لسيارتك", "خلوص البراغي (PCD): مثل 5x114.3 — الخطأ فيه يعني عدم إمكانية التركيب أصلاً", "العرض والإزاحة (Offset): يؤثران على بروز الجنط خارج الهيكل أو داخله"],
      },
      {
        h2: "التركيب الصحيح للجنوط",
        body: "التركيب ليس مجرد ربط صواميل: كل جنط يحتاج موازنة (بأوزان ترصيص مناسبة له)، وربطاً بحساب العزم الصحيح، وفحصاً بعد مسافة قصيرة من القيادة للتأكد من عدم وجود اهتزاز. هذا ما ننفذه في كل زيارة — لأن الجنط المركب صحيحاً يعني قيادة هادئة وعمراً أطول للكفر.",
      },
      {
        h2: "الجنوط المناسبة لسيارات الرياض",
        body: "أحياء الرياض تعرف استخدامات مختلفة: سيارات عائلية تحتاج جنوطاً عملية بمقاس 16-17، سيارات فخمة تناسبها 18-19 بتصاميم أنيقة، والسيارات الرياضية تحتاج مقاسات أكبر مع كفرات رياضية. أخبرنا بنوع سيارتك وما تفضله من مظهر — وسنقترح عليك الخيارات المتوافقة فعلاً مع سيارتك، لا مجرد أشكال جميلة.",
      },
    ],
    features: ["مقاسات من 16 إلى 19 بوصة", "فحص توافق كامل قبل التركيب", "تركيب وموازنة في موقعك", "تشكيلات تناسب كل الأذواق"],
    faqs: [
      { q: "كيف أختار الجنط المناسب لمقاس كفرتي؟", a: "أرسل لنا مقاس كفرك ونوع سيارتك عبر واتساب، وسنرشدك للجنط المتوافق معها من ناحية القطر وخلوص البراغي والعرض — قبل أي شراء." },
      { q: "هل تجهزون جنوطاً للسيارات الفخمة؟", a: "نعم، لدينا تشكيلات تناسب السيارات الفخمة والرياضية بمقاسات 18 و19 بوصة." },
      { q: "هل التركيب يشمل الكفرات؟", a: "نعم، نركب الكفرات على الجنوط الجديدة ونوازن كل عجلة — ويمكنك طلب الكفرات من عندنا أو إحضارها معك." },
      { q: "هل يمكن ترصيص الجنوط القديمة بدل استبدالها؟", a: "الترصيص يعالج اهتزاز العجلة الناتج عن اختلاف الوزن، لكن إذا كان الجنط محدباً أو متضرراً بشكل واضح فالأفضل استبداله — وسنشرح لك الحالة بعد الفحص." },
    ],
  }),
  svc({
    slug: "برمجة-حساسات-الكفرات",
    name: "برمجة حساسات الكفرات TPMS",
    h1: "برمجة حساسات الكفرات TPMS في الرياض",
    title: "برمجة حساسات الكفرات TPMS الرياض | نجم الإطار",
    description: "برمجة حساسات الكفرات TPMS في الرياض — تركيب وبرمجة الحساسات بعد تغيير الكفرات وإطفاء لمبة التحذير. خدمة متنقلة 24 ساعة. واتساب 0538644740.",
    image: IMG.grayRim,
    alt: "تركيب حساس ضغط كفرات TPMS على عجلة سيارة في الرياض",
    intro: [
      "لمبة حساس الكفر (TPMS) على لوحة العدادات ليست مجرد إشارة — إنها تراقب ضغط كل كفر مباشرة عبر حساسات صغيرة داخل العجلات. عندما تُستبدل هذه الحساسات أو تنتهي بطاريتها أو بعد تغيير الكفرات، تحتاج إلى برمجة صحيحة لتتعرف عليها السيارة — وهذه خدمة نقدمها في موقعك.",
      "الفريق المجهز لدينا يحمل أجهزة برمجة TPMS تدعم أنواع الحساسات الشائعة في السوق، فيقرأ الحساسات الحالية، يبرمج الحساسات الجديدة، ويتأكد من ظهور القيم الصحيحة لكل عجلة على شاشة السيارة — دون رحلة وكالة.",
    ],
    sections: [
      {
        h2: "متى تحتاج الحساسات إلى برمجة؟",
        body: "أكثر الحالات التي نتعامل معها:",
        list: ["تركيب حساس جديد بعد فك الكفر عن الجنط أو تلف الحساس القديم", "إطفاء لمبة التحذير بعد التأكد من ضغط الكفرات الصحيح", "إعادة برمجة بعد تغيير الكفرات أو تبديلها بين العجلات", "حساس لم يعد يظهر قيمته بسبب انتهاء بطاريته"],
      },
      {
        h2: "كيف تعمل خدمة برمجة TPMS المتنقلة؟",
        body: "الفني يصل إلى موقعك بجهاز القراءة والبرمجة، يقرأ حالة كل حساس (ضغط، بطارية، هوية الحساس)، ثم يبرمج الحساس الجديد برقم التعريف الخاص به ويسجله في نظام السيارة، ويضبط الضغط الصحيح لكل عجلة. بعد ذلك تتأكد أن لوحة العدادات تعرض قيماً صحيحة لكل كفر.",
      },
      {
        h2: "لماذا لا تتجاهل لمبة TPMS؟",
        body: "لأن انخفاض الضغط يزيد حرارة الكفر ويقصّر عمره ويرفع استهلاك الوقود. اللمبة إما تحذير من نقص ضغط حقيقي — وهنا نصلح المشكلة — أو من حساس معطل أو بطارية انتهت — وهنا نستبدل الحساس ونعيد برمجته. في الحالتين، نحل المشكلة في موقعك.",
      },
    ],
    features: ["قراءة وتشخيص كل حساس", "برمجة حساسات جديدة", "إطفاء لمبة التحذير", "ضبط ضغط مطابق لمواصفات السيارة"],
    faqs: [
      { q: "متى تحتاج الحساسات إلى برمجة؟", a: "عند تركيب حساس جديد، أو بعد تغيير الكفرات أو نقلها، أو عند ظهور لمبة التحذير مع ضغط صحيح — ما يعني أن الحساس بحاجة إلى برمجة أو استبدال." },
      { q: "ما عمر بطارية حساس TPMS؟", a: "عادة تعمل البطارية المدمجة سنوات طويلة من الاستخدام العادي، وعند انتهائها يظهر الحساس كغير متصل ويلزم استبداله." },
      { q: "هل توفرنون الحساسات؟", a: "نعم، نوفر حساسات TPMS متوافقة مع أنواع السيارات الشائعة، مع التركيب والبرمجة في موقعك." },
      { q: "هل الخدمة متاحة لجميع السيارات؟", a: "أجهزتنا تدعم الأنظمة الشائعة في السوق السعودي. أرسل لنا نوع سيارتك وسنة الموديل عبر واتساب للتأكد قبل زيارة الفني." },
    ],
  }),
  svc({
    slug: "خدمة-الإطارات-المتنقلة",
    name: "خدمة الإطارات المتنقلة",
    h1: "خدمة الإطارات المتنقلة — ورشتك المتنقلة في الرياض",
    title: "خدمة الإطارات المتنقلة | كل خدمات الكفرات في موقعك — نجم الإطار",
    description: "خدمة الإطارات المتنقلة في الرياض: إصلاح، تغيير، ترصيص، هواء وبرمجة TPMS — كل ما تحتاجه إطار سيارتك في الموقع نفسه. 24 ساعة. واتساب 0538644740",
    image: IMG.assorted,
    alt: "خدمة إطارات متنقلة كاملة في موقع العميل بالرياض",
    intro: [
      "خدمة الإطارات المتنقلة هي الفكرة التي بُني عليها نجم الإطار: بدل أن تأتي أنت إلى الورشة، تأتي الورشة إلى أنت. سيارتنا المجهزة تحمل كل ما يحتاجه إطارك — من الإصلاح والتغيير إلى الترصيص والبرمجة — وتصل إلى أي نقطة في الرياض على مدار الساعة.",
      "هذه الخدمة مناسبة لكل من أوقاته مزدحمة: موظف لا يريد تعطيل يومه، أسرة معها أطفال لا تتسع لانتظار ورشة، مسافر يريد فحص إطاراته قبل رحلة، أو شركة لديها أسطول سيارات تحتاج صيانة إطارات منتظمة في موقعها.",
    ],
    sections: [
      {
        h2: "كل ما تحتاجه إطارك في زيارة واحدة",
        body: "قائمة خدماتنا المتنقلة كاملة:",
        list: ["إصلاح البنشر وإغلاق الثقوب", "تغيير وتركيب الكفرات مع الموازنة", "تجهيز إطارات جديدة بماركات عالمية", "تجهيز وتركيب الجنوط وفحص التوافق", "ترصيص الإطارات لمعالجة الاهتزاز", "فحص وتعبئة الهواء وضبط الضغط", "برمجة حساسات الكفرات TPMS"],
      },
      {
        h2: "لمن تصلح هذه الخدمة؟",
        body: "نخدم شرائح مختلفة في الرياض:",
        list: ["الأفراد والأسرة: صيانة وإصلاح في المنزل دون خروج", "الموظفون: إنجاز الخدمة في موقف العمل خلال وقت قصير", "الأسطول التجاري: صيانة إطارات منتظمة في موقع الشركة", "المسافرون: فحص وتجهيز الإطارات قبل الرحلة"],
      },
      {
        h2: "كيف تعمل الخدمة؟",
        body: "ابدأ بطلب بسيط: راسلنا على واتساب واذكر ما تحتاجه، ثم أرسل موقعك عبر زر «أرسل موقعك للفني». يتحرك الفني المجهز إليك، يفحص الحالة، يشرح لك الخيارات والسعر، وبعد موافقتك ينفذ العمل في الموقع. عند الانتهاء ستكون سيارتك جاهزة للانطلاق — وهذا هو المعنى الحقيقي للخدمة المتنقلة.",
      },
    ],
    features: ["كل خدمات الإطار في موقعك", "مناسب للأفراد والأسرة والشركات", "مواعيد مرنة على مدار الساعة", "شفافية كاملة في الحالة والسعر"],
    faqs: [
      { q: "ما الفرق بين البنشر المتنقل والورشة؟", a: "الفرق في المكان لا في الجودة: نصل إليك بالمعدات الأساسية — فك وتركيب وموازنة وترصيص وبرمجة — وتوفر رحلة الذهاب والعودة والانتظار." },
      { q: "هل الخدمة مناسبة للشركات والأسطول؟", a: "نعم، نقدم خدمة دورية للأسطول في موقع الشركة، بما يوفر على الإدارة تتبع سيارات موزعة في أنحاء الرياض." },
      { q: "كيف أبدأ؟", a: "راسلنا على واتساب، اذكر المشكلة وأرسل موقعك — وسنتحرك إليك مباشرة." },
      { q: "هل تخدمون ضواحي الرياض؟", a: "نغطي الرياض كاملة وضواحيها الملاصقة. لأي منطقة خارج المدينة، تواصل معنا عبر واتساب لترتيب الزيارة." },
    ],
  }),
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
